import { Component, OnInit, Input } from '@angular/core';
import { PreRepossession } from '../../model/staterequirements.model';

@Component({
  selector: 'app-state-requirement-prerepossession',
  templateUrl: './state-requirement-prerepossession.component.html',
  styleUrls: ['./state-requirement-prerepossession.component.css']
})
export class StateRequirementPrerepossessionComponent implements OnInit {
  public role : string;
  public showFlag: boolean = false;
  private _preRepossession: PreRepossession;
  public parClicked: any;
  public agentClicked: any;
  public get preRepossession(): PreRepossession {
    return this._preRepossession;
  }
  @Input()
  public set preRepossession(value: PreRepossession) {
    if (typeof value !== 'undefined' && value !== null) {
    this._preRepossession = value; }
    else{
      this._preRepossession = new PreRepossession();
    }
  }

  constructor() {
    this._preRepossession = new PreRepossession();
  }

  ngOnInit() {
    this.role = localStorage.getItem("Role");
    this.parClicked = localStorage.getItem("parClicked");
    this.agentClicked = localStorage.getItem("agentClicked");
    if(this.role === "PC PAR Vendor Relations" || this.role === "PC Client" && (this.agentClicked ==="false" && this.parClicked === "false")){
      this.showFlag = true;
    }
    else if (this.role === "PC Client" && this.agentClicked === "true") {
      this.showFlag = true;
    }
    else if (this.role === "PC Client" && this.parClicked === "true") {
      this.showFlag = true;
    }
    else if (this.role === "PC PAR Admin" && this.agentClicked === "true") {
      this.showFlag = true;
    }
    else if (this.role === "PC PAR Admin" && this.parClicked === "true") {
      this.showFlag = false;
    }
    else
    {
      this.showFlag = false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/state-requirement-prerepossession/state-requirement-prerepossession.component.ts